import {
  alpha,
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import React from "react";
import { HiOutlineMail, HiOutlineMap, HiOutlinePhone } from "react-icons/hi";
import GMapDynamic from "./gmap.dynamic";

const Contact: React.FC = () => {
  const { consent } = useCookieConsentContext();
  const {
    palette: { mode },
  } = useTheme();
  return (
    <>
      <Box
        sx={(theme) => ({
          minHeight: 250,
          height: 500,
          overflowX: "hidden",
          position: "relative",
          background: "url('/map.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          overflow: "hidden",

          [theme.breakpoints.down("sm")]: { display: "none" },
        })}
      >
        <GMapDynamic />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 200,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Paper
            sx={(theme) => ({
              padding: theme.spacing(4),
              backgroundColor:
                theme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.8)"
                  : alpha(theme.palette.background.paper, 0.8),
              display: "flex",
              flexDirection: "column",
              gap: 1,
            })}
          >
            <Typography variant="h5" component="h4" sx={{ fontWeight: "bold" }}>
              Pivovarská restaurace v Čáslavi
            </Typography>
            <Divider sx={{ width: 80, marginY: 1 }} />
            <List
              disablePadding
              sx={{
                "& > li > a": {
                  width: "100%",
                },
              }}
            >
              <ListItem>
                <a
                  href="https://goo.gl/maps/ERgEMxjxXrknQo4E9"
                  target="_blank"
                  rel="noreferrer"
                >
                  <ListItemButton>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <HiOutlineMap size={25} />
                      <Typography>
                        Žacká 1783,
                        <br />
                        286 01 Čáslav
                      </Typography>
                    </Box>
                  </ListItemButton>
                </a>
              </ListItem>
              <ListItem>
                <a href="tel:+420 773 143 700">
                  <ListItemButton>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <HiOutlinePhone size={25} />
                      <Typography>+420 773 143 700</Typography>
                    </Box>
                  </ListItemButton>
                </a>
              </ListItem>
              <ListItem>
                <a
                  href="mailto:info@pivovarcaslav.cz"
                  target="_blank"
                  rel="noreferrer"
                >
                  <ListItemButton>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <HiOutlineMail size={25} />
                      <Typography>info@pivovarcaslav.cz</Typography>
                    </Box>
                  </ListItemButton>
                </a>
              </ListItem>
            </List>
          </Paper>
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          [theme.breakpoints.up("sm")]: { display: "none" },
          padding: theme.spacing(3),
        })}
      >
        <Paper
          sx={(theme) => ({
            padding: theme.spacing(4),
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          })}
        >
          <Typography variant="h5" component="h4" sx={{ fontWeight: "bold" }}>
            Pivovarská restaurace v Čáslavi
          </Typography>
          <Divider sx={{ width: 80, marginY: 1 }} />
          <List disablePadding>
            <a
              href="https://goo.gl/maps/ERgEMxjxXrknQo4E9"
              target="_blank"
              rel="noreferrer"
            >
              <ListItem>
                <ListItemButton>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <HiOutlineMap size={25} />
                    <Typography>
                      Žacká 1783,
                      <br />
                      286 01 Čáslav
                    </Typography>
                  </Box>
                </ListItemButton>
              </ListItem>
            </a>
            <a href="tel:+420 773 143 700">
              <ListItem>
                <ListItemButton>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <HiOutlinePhone size={25} />
                    <Typography>+420 773 143 700</Typography>
                  </Box>
                </ListItemButton>
              </ListItem>
            </a>
            <a
              href="mailto:info@pivovarcaslav.cz"
              target="_blank"
              rel="noreferrer"
            >
              <ListItem>
                <ListItemButton>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <HiOutlineMail size={25} />
                    <Typography>info@pivovarcaslav.cz</Typography>
                  </Box>
                </ListItemButton>
              </ListItem>
            </a>
          </List>
        </Paper>
      </Box>
    </>
  );
};

export default Contact;
